import { ExportToCsv } from "export-to-csv";
import { Order } from "./order.model";
import * as moment from "moment-timezone";
import { TimeframeFilter } from "../timeframe/timeframes";

export class OrderExporter {
  public exporter: ExportToCsv;

  constructor(public orders: Order[], public tf: TimeframeFilter) {}

  getFileName(): string {
    let begin = moment(this.tf.begin)
      .format("ll")
      .replace(", ", "")
      .replace(" ", "");
    let end = moment(this.tf.end)
      .format("ll")
      .replace(", ", "")
      .replace(" ", "");
    return "LineLeapOrders_" + begin + "-to-" + end;
  }

  public get options() {
    return {
      filename: this.getFileName(),
      fieldSeparator: ",",
      quoteStrings: '"',
      decimalSeparator: ".",
      showLabels: true,
      showTitle: true,
      title: "Orders",
      useTextFile: false,
      useBom: true,
      useKeysAsHeaders: true
    };
  }

  toCSV(order: Order, isAdmin: boolean) {
    let x = order.toCSV();
    if (!isAdmin) {
      delete x["Customer Email"];
      delete x["Customer Name"];
      delete x["City"];
      x["Customer ID"] = order.user.reference.id;
    }
    return x;
  }
  export(isAdmin: boolean) {
    this.exporter = new ExportToCsv(this.options);
    let data = this.orders.map(order => this.toCSV(order, isAdmin));
    this.exporter.generateCsv(data);
  }
}
